import { Col, Form, InputNumber, Modal, Row } from 'antd'
import React from 'react'

interface DormRoomModalProps {
    form: any;
    open: boolean;
    onFinish: (values: any) => void;
    onCancel: () => void;
}


const DormRoomModal = ({ form, open, onCancel, onFinish }: DormRoomModalProps) => {
    return (
        <Modal
            title="Dormitory Room and Floor information"
            onOk={() => form.submit()}
            open={open}
            destroyOnClose
            onCancel={onCancel}
        >
            <Form
                form={form}
                name="dormitoryRoom"
                onFinish={onFinish}
                layout="vertical"
            >
                <Form.Item
                    label="Id"
                    name="id"
                    hidden
                    noStyle
                >
                    <InputNumber />
                </Form.Item>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            label="Number"
                            name="number"
                            rules={[{ required: true, message: 'Please input the number!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            label="Flat Number"
                            name="flat_number"

                            rules={[{ required: true, message: 'Please input the flat number!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            label="Floor"
                            name="floor"
                            rules={[{ required: true, message: 'Please input the floor!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            label="Beds"
                            name="beds"
                            rules={[{ required: true, message: 'Please input the beds!' }]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}

export default DormRoomModal